(function ($) {
	"use strict";
	let blockwheelsBlocksGalleryMagnific = {
		initAll: function () {

			const elementList = document.querySelectorAll(
				'.wp-block-blockwheels-masonry-gallery.masonry-gallery-magnific-init'
			);

			if (!elementList || elementList.length === 0) {
				return;
			}
			// Magnific Popup
			[...elementList].forEach((gallery) => {
				const galleryId = $(gallery).data('id');
				$(`#${galleryId}`).magnificPopup({
					delegate: 'a',
					type: 'image',
					gallery: {
						enabled: true,
						navigateByImgClick: true,
						preload: [0, 1],
					}
				});
			});
		},
		// Initiate the menus when the DOM loads.
		init: function () {
			blockwheelsBlocksGalleryMagnific.initAll();
		},
	};
	if (document.readyState === "loading") {
		// The DOM has not yet been loaded.
		document.addEventListener("DOMContentLoaded", blockwheelsBlocksGalleryMagnific.init);
	} else {
		// The DOM has already been loaded.
		blockwheelsBlocksGalleryMagnific.init();
	}
})(jQuery);